var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01447a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1068 126h-936c-39.719 0-72 32.281-72 72v552c0 39.719 32.281 72 72 72h457.08c12.238 141 130.8 252 274.92 252 152.16 0 276-123.84 276-276v-600c0-39.719-32.281-72-72-72zm-204 900c-125.76 0-228-102.24-228-228s102.24-228 228-228 228 102.24 228 228-102.24 228-228 228zm228-383.28c-49.801-72.84-133.32-120.72-228-120.72-144.12 0-262.68 111-274.92 252h-457.08c-13.199 0-24-10.801-24-24v-336h984zm0-276.72h-984v-72h984zm0-120h-984v-48c0-13.199 10.801-24 24-24h936c13.199 0 24 10.801 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204 702h120c13.199 0 24-10.801 24-24s-10.801-24-24-24h-120c-13.199 0-24 10.801-24 24s10.801 24 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444 702h48c13.199 0 24-10.801 24-24s-10.801-24-24-24h-48c-13.199 0-24 10.801-24 24s10.801 24 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m919.08 709.08-144 144c-9.4805 9.3594-9.4805 24.48 0 33.84 4.6797 4.6797 10.801 7.0781 16.922 7.0781s12.238-2.3984 16.922-7.0781l144-144c9.4805-9.3594 9.4805-24.48 0-33.84-9.3633-9.4766-24.48-9.4766-33.844 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m816 726c0 13.254-10.746 24-24 24s-24-10.746-24-24 10.746-24 24-24 24 10.746 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m960 870c0 13.254-10.746 24-24 24s-24-10.746-24-24 10.746-24 24-24 24 10.746 24 24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/payment-card.1a484ba2e4bc6b22d160afc36a6caf2f.svg";
export { ForwardRef as ReactComponent };